import styled from 'styled-components';
import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';
import { Text } from '@lux/text';

export const ReservedWrapperPopover = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) translate3d(0, 0, 0) perspective(1px) scale3d(1, 1, 1);
    width: 90%;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    color: #1a1a1a;
    position: fixed;
    z-index: 1000;

    ${screenBiggerThan(Screen.smallTablet)} {
        width: 100%;
        height: 100%;
    }
`;

export const ReservedArticlePopover = styled.div`
    ${screenBiggerThan(Screen.smallTablet)} {
        width: 80%;
    }
`;

export const ReservedArticleHeadline = styled(Text)`
    text-align: center;
    padding: 20px 0;

    ${screenBiggerThan(Screen.smallTablet)} {
        padding-top: 0;
    }
`;

export const ReservedArticleBody = styled(Text)`
    line-height: 17px;
    padding: 0 20px 20px 20px;
    white-space: initial;

    ${screenBiggerThan(Screen.smallTablet)} {
        padding: 0 0 20px 0;
    }
`;

export const ReservedArticleCloseSt = styled.div`
    line-height: 50px;
    text-align: center;
    border-top: 1px solid #e0e0e0;

    ${screenBiggerThan(Screen.smallTablet)} {
        border: 1px solid #1a1a1a;
        border-radius: 3px;
        line-height: 40px;
        cursor: pointer;
    }
`;
